export enum VariableTableField {
  KEY = 'key',
  VALUE = 'value',
  REGEX_RULE = 'regexRule',
  DESCRIPTION = 'description',
  MODIFIED = 'modified',
  CREATED_AUTHOR = 'createdAuthor',
  USED = 'used',
  ACTIONS = 'actions',
}
